module.exports = __webpack_public_path__ + "img/title_next_red.de391275.png";